export function getLoyaltyBonusPointsCampaignType({ bonusPoints, basePoints }: {
  basePoints: number,
  bonusPoints: number,
}): App.LoyaltyBonusPointsCampaignType | undefined {
  if (!bonusPoints) return
  switch (bonusPoints / basePoints) {
    case 1:
      return 'double'
    case 2:
      return 'triple'
    default:
      return 'static'
  }
}

function determineLoyaltyBonusPointsCampaignType(calculation: Omit<App.LoyaltyPointsEarnCalculation, 'request'>): App.LoyaltyBonusPointsCampaignType | undefined
function determineLoyaltyBonusPointsCampaignType(calculation: App.LoyaltyPointsEarnCalculation): App.LoyaltyBonusPointsCampaignType | undefined {
  return getLoyaltyBonusPointsCampaignType({
    basePoints: calculation.basePoints,
    bonusPoints: calculation.bonusPoints,
  })
}

export default determineLoyaltyBonusPointsCampaignType
